/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferralRequest
 */
export interface UpdateReferralRequest {
    /**
     * The target discharge date for the referral
     */
    target_discharge_date: Date;
}

/**
 * Check if a given object implements the UpdateReferralRequest interface.
 */
export function instanceOfUpdateReferralRequest(value: object): value is UpdateReferralRequest {
    if (!('target_discharge_date' in value) || value['target_discharge_date'] === undefined) return false;
    return true;
}

export function UpdateReferralRequestFromJSON(json: any): UpdateReferralRequest {
    return UpdateReferralRequestFromJSONTyped(json, false);
}

export function UpdateReferralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target_discharge_date': (json['target_discharge_date'] == null ? json['target_discharge_date'] : parseDate(json['target_discharge_date'])),
    };
}

export function UpdateReferralRequestToJSON(json: any): UpdateReferralRequest {
    return UpdateReferralRequestToJSONTyped(json, false);
}

export function UpdateReferralRequestToJSONTyped(value?: UpdateReferralRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_discharge_date': value['target_discharge_date'] == null ? value['target_discharge_date'] : serializeDate(value['target_discharge_date']),
    };
}

